import styled from 'styled-components';

export const Container = styled.div`
  .custom-tabs {
    border-bottom: 1px solid #dee2e6;
  }

  .custom-tabs .nav-link {
    border: none;
    background: transparent;
    color: #0d6efd;
    font-weight: 500;
    padding: 10px 16px;
  }

  .custom-tabs .nav-link:hover {
    border: none;
    color: #0d6efd;
  }

  .custom-tabs .nav-link.active {
    color: #1f2d3d;
    border: none;
    border-bottom: 3px solid #0d6efd;
    background: transparent;
  }

  .card-hover {
    transition: all 0.25s ease;
    cursor: pointer;
  }

  .card-hover:hover {
    transform: scale(1.04);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  }

  .d-none-print {
    display: none;
  }

  @media print {
    .page-break {
      page-break-before: always;
    }
  }

  button.card {
    background: white;
    border: 1px solid #dee2e6;
    width: 100%;
  }

  .manifestation-wrapper {
    padding-top: 8px;
  }

  .manifestation-card {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 12px;
    padding: 18px;
  }

  .manifestation-heading {
    font-weight: 700;
    text-align: center;
    margin-bottom: 16px;
  }

  .manifestation-editor-shell {
    border: 1px solid #d8dee8;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }

  .manifestation-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px;
    border-bottom: 1px solid #e8edf3;
    background: #f8fafc;
  }

  .toolbar-button {
    width: 38px;
    height: 38px;
    border: 1px solid #d8dee8;
    border-radius: 8px;
    background: #fff;
    color: #334155;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  }

  .toolbar-button:hover {
    background: #eff6ff;
    border-color: #93c5fd;
    color: #0f62fe;
  }

  .manifestation-editor {
    min-height: 520px;
    max-height: 700px;
    overflow-y: auto;
    padding: 28px 26px;
    font-size: 16px;
    line-height: 1.8;
    color: #111827;
  }

  .manifestation-editor:focus {
    outline: none;
  }

  .manifestation-editor p {
    margin-bottom: 18px;
  }

  .manifestation-editor ul,
  .manifestation-editor ol {
    padding-left: 28px;
    margin-bottom: 18px;
  }

  .manifestation-title {
    text-align: center;
    font-size: 20px;
    margin-bottom: 28px;
  }

  .manifestation-highlight {
    background: #fff0a8;
    padding: 1px 4px;
    font-weight: 700;
  }

  .manifestation-actions {
    display: flex;
    justify-content: center;
    margin-top: 18px;
  }

  @media (max-width: 768px) {
    .manifestation-card {
      padding: 14px;
    }

    .manifestation-editor {
      min-height: 420px;
      padding: 18px 16px;
    }

    .manifestation-actions {
      flex-direction: column;
      gap: 12px;
    }
  }
`;
